import { render } from "./PunyForm.vue?vue&type=template&id=8a84c93e"
import script from "./PunyForm.vue?vue&type=script&lang=js"
export * from "./PunyForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__